import React from "react";
import { Box, MenuItem, Select, Stack } from "@mui/material";
import UnfoldMoreOutlinedIcon from "@mui/icons-material/UnfoldMoreOutlined";
import { useTranslation } from "../context/Internationalization";
import { colors } from "../theme/colors";
import { fonts } from "../theme/fonts";
import ClubLogo from "./ClubLogo";

const ClubIdentity = ({ club, season, seasonLabel }) => (
  <Stack direction="row" spacing={1.5} alignItems="center" sx={{ minWidth: 0 }}>
    <ClubLogo club={club} />
    <Box sx={{ minWidth: 0 }}>
      <Box
        component="span"
        title={club.name}
        sx={{
          ...fonts.text.sm.medium,
          display: "block",
          color: colors.Base.White,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {club.name}
      </Box>
      <Box
        component="span"
        title={`${seasonLabel}: ${season}`}
        sx={{
          ...fonts.text.xs.normal,
          display: "block",
          color: colors.Grey[400],
        }}
      >
        {season}
      </Box>
    </Box>
  </Stack>
);

const SidebarClubHeader = ({
  club,
  clubs = [],
  selectedClubId,
  season,
  onClubChange,
}) => {
  const { t } = useTranslation();

  if (!club?._id) {
    return (
      <Box sx={{ p: 3 }}>
        <ClubLogo />
      </Box>
    );
  }

  const value = selectedClubId || club._id;
  const displayedClub =
    value === club._id
      ? club
      : clubs.find((option) => option._id === value) || club;
  const identity = (
    <ClubIdentity
      club={displayedClub}
      season={season}
      seasonLabel={t("season")}
    />
  );

  return (
    <Box sx={{ p: 2 }}>
      {clubs.length > 1 ? (
        <Select
          fullWidth
          name="selectClub"
          value={value}
          onChange={(event) => onClubChange(event.target.value)}
          renderValue={() => identity}
          IconComponent={UnfoldMoreOutlinedIcon}
          inputProps={{ "aria-label": t("club") }}
          sx={{
            color: colors.Base.White,
            borderRadius: "8px",
            "& .MuiSelect-select": { minWidth: 0, py: 1, pl: 1, pr: 4.5 },
            "& .MuiSelect-icon": { color: colors.Grey[400] },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "transparent",
            },
            "&:hover": { backgroundColor: colors.Grey[800] },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: colors.Grey[700],
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: colors.Base.PlayerDex,
            },
          }}
        >
          {clubs.map((option) => (
            <MenuItem key={option._id} value={option._id}>
              {option.name}
            </MenuItem>
          ))}
        </Select>
      ) : (
        <Box sx={{ p: 1 }}>{identity}</Box>
      )}
    </Box>
  );
};

export default SidebarClubHeader;
